<template>
    <div>

        <div class="top-content">
            <!--<p class="money">¥2.00</p>-->
            <p><i class="weui-icon-success weui-icon_msg"></i>支付成功</p>
        </div>

        <!--<p class="tips">请在<span>15分钟内</span>（18:08之前）离场</p>-->
        <!--<div class="weui-btn-area">-->
        <!--<button class="weui-btn weui-btn_primary" @click="handleRation">开 票</button>-->
        <!--</div>-->
    </div>
</template>

<script>

export default {
    name: "roadside",


}
</script>

<style scoped lang="stylus">
	.top-content{
        
		border-bottom 1px solid #e6e6e6
		padding 20px 0
		margin 50% 20px
		display flex
		/*flex-direction column*/
		justify-content center
		/*align-items center*/
		.money{
			font-size 36px
			font-weight 500
			color #06ae56
            
		}
		p:last-child{
			padding-top 10px
			display flex
			align-items center
			.weui-icon-success{
				width 20px
				height: 20px;
			}
		}

	}
	
</style>

